module.exports = __webpack_public_path__ + "img/chinesecompany223.168e6b86.png";